import { render, staticRenderFns } from "./AdminAddPromotion2024.vue?vue&type=template&id=614e97c1&scoped=true"
import script from "./AdminAddPromotion2024.vue?vue&type=script&lang=js"
export * from "./AdminAddPromotion2024.vue?vue&type=script&lang=js"
import style0 from "./AdminAddPromotion2024.vue?vue&type=style&index=0&id=614e97c1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "614e97c1",
  null
  
)

export default component.exports